<script>
import MindMovieSinglePost from './MindMovieSinglePost.vue';

export default {
  props: {
    post: { type: Object, required: true },
    threshold: { type: Number, default: 1000 } // px below viewport
  },
  components: { MindMovieSinglePost },
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  methods: {
    setupObserver() {
      if (!this.$refs.lazyContainer) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.observer.disconnect(); // one and done
          }
        });
      }, {
        rootMargin: `0px 0px ${this.threshold}px 0px`, // 1000px below
        threshold: 0.01
      });

      this.observer.observe(this.$refs.lazyContainer);
    }
  },
  mounted() {
    // Small delay so the DOM is ready
    this.$nextTick(() => {
      this.setupObserver();
    });
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  }
};
</script>

<template>
  <div ref="lazyContainer" class="lazy-single-post-wrapper">
    <MindMovieSinglePost v-if="isVisible" :post="post" />

    <!-- Placeholder while not loaded -->
    <div v-else class="post-placeholder">
      <v-skeleton-loader
        type="image, article"
        height="420"
        class="mb-4"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<style scoped>
.lazy-single-post-wrapper {
  min-height: 420px; /* prevents layout shift */
}
.post-placeholder {
  border: 1px solid #333;
  border-radius: 8px;
}
</style>
